import {Checkbox, FormControlLabel} from '@mui/material';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

const useSwitchStyles = makeStyles((theme) => ({
    label: {
        fontFamily: 'Inter',
        fontWeight: 400,
        '&.small': {
            fontSize: 'small',
        },
    },
    root: {
        '&.small': {
            height: 32,
        },
    },
    noMargin: {
        marginRight: 0,
    },
    error: {
        color: theme.palette.error.main,
    },
}));

const AgyleCheckBox = (props) => {
    const classes = useSwitchStyles();

    return (
        <FormControlLabel
            disabled={props.disabled}
            name={props.name}
            className={clsx(classes.root, props.size, props.noMargin && classes.noMargin)}
            control={
                <Checkbox
                    checked={props.value}
                    onChange={props.onChange}
                    name={props.name}
                    size={props.size}
                    className={clsx(props.error && classes.error)}
                    readOnly={props.readOnly}
                />
            }
            label={
                <span className={clsx(classes.label, props.size, props.labelClasses)}>
                    {props.label}
                </span>
            }
        />
    );
};

export default AgyleCheckBox;

AgyleCheckBox.propTypes = {
    value: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.string,
    name: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    labelClasses: PropTypes.any,
    readOnly: PropTypes.bool,
};

AgyleCheckBox.defaultProps = {
    value: false,
    disabled: false,
    error: false,
    readOnly: false,
    label: '',
};